import React from 'react';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { useSelector } from 'react-redux';
import { useReportOptions } from '../../hooks/useReportOptions.js';
import Select from '../../../common/Select.jsx';
import styles from '../base/CommonSettings.module.scss';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';

function WorkflowStatusTrackerWidgetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const workflow_id = useSelector(state => state.dashboard.widgets[widgetId].settings?.workflow_id);
    const {data: workflowOptions} = useReportOptions();

    return (<>
        <hr />
        <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <div styles={styles['settings-option']}>
                <label className="w-100">
                {I18n.t("monitoring_reports")}
                <Select
                    value={workflow_id}
                    options={(workflowOptions || []).map(v => ({value: v.id, label: v.name}))} 
                    isMulti = {false}
                    onChange={(v) => setAttribute("settings.workflow_id", v)}
                /> 
                </label>
            </div>
        </CollapsibleSection>
    </>);
}

export default WorkflowStatusTrackerWidgetSettings;
